<script lang="ts">
import formFieldsInit from '../../utils/formFieldsInit.vue'
import FormLabel from './label.vue'

export default {
    name: 'NumberField',
    components: { FormLabel },
    extends: formFieldsInit,
    props: {
        step: { type: Number, required: false, default: 1 },
        precision: { type: Number, required: false, default: 0 },
        controlVariant: { type: String, required: false, default: 'default' },
    },
    emits: ['input', 'updateData'],
    computed: {
        min(): number | undefined {
            const minRule = this.rule?.find(rule => rule.startsWith('min:'))
            if (minRule) {
                return Number(minRule.replace('min:', ''))
            }
            return undefined
        },
        max(): number | undefined {
            const maxRule = this.rule?.find(rule => rule.startsWith('max:'))
            if (maxRule) {
                return Number(maxRule.replace('max:', ''))
            }
            return undefined
        },
        strNumber(): string {
            const number = this.value
            return number.toLocaleString(undefined, {
                maximumFractionDigits: 100,
            })
        },
    },
}
</script>

<template>
    <FormLabel v-if="(data || injectedData || formService?.data) && (value !== undefined || rule)">
        <!--      TODO fix min max pour fonctionner comme https://vuetifyjs.com/en/components/number-inputs/#min-max -->
        <!-- Le min/max de l'input chiffre est basculé sur minValue/maxValue (on veut que la vérif soit faite sur la valeur, et non pas la longueur de la valeur) -->

        <v-number-input
            v-if="rule"
            :id="customId ?? dataKey"
            :name="customId ?? dataKey"
            class="custom-input"
            type="number"
            clearable
            density="compact"
            :disabled="disabled"
            variant="outlined"
            :suffix="suffix"
            :placeholder="placeholder"
            :step
            :precision
            :min
            :max
            :model-value="typeof value === 'number' ? value : Number(value)"
            :control-variant="!step ? 'hidden' : controlVariant"
            persistent-hint
            :hint="getInfo()"
            :error-messages="getErrors()"
            @input="(validation && validation.$touch()) || injectedValidation?.$touch(); $emit('input', $event)"
            @blur="validation && validation.$touch()"
            @update:model-value="$emit('updateData', $event); updateData($event)"
        >
            <!-- :max="getMax()" -->
            <template #append-inner>
                <slot name="appendInnerIcon"/>
            </template>
        </v-number-input>
        <div v-else>
            <div v-if="typeof value === 'number'">
                <div v-if="withTooltip">
                    <v-tooltip :text="$translate(`${translationName}.${dataKey}.tooltip.${value}`)">
                        <template #activator="{ props }">
                            <v-chip
                                v-if="isChips"
                                v-bind="props"
                                :variant="$config.public.chips_variant || 'tonal'"
                            >
                                {{ strNumber }} {{ suffix }}
                            </v-chip>
                            <span
                                v-else
                                v-bind="props"
                            >{{ strNumber }} {{ suffix }}</span>
                        </template>
                    </v-tooltip>
                </div>
                <v-chip v-if="isChips" :variant="$config.public.chips_variant || 'tonal'">
                    {{ strNumber }} {{ suffix }}
                </v-chip>
                <span v-else>{{ strNumber }} {{ suffix }}</span>
                <slot name="appendContent"/>
            </div>
            <div v-else>
                <small class="font-italic text-disabled">-</small>
            </div>
        </div>
    </FormLabel>
</template>
